import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Popover } from 'antd'
import styled from 'styled-components'
import { colours, sizes } from '@qflow/theme'

import { useModuleIds } from 'portal/lib/hooks'
import { Flex, icons, ColourButton, Spacer } from 'portal/lib/primitives'
import {
  uiSetShownDeliveryTableColumns,
  uiSetShownWasteTableColumns
} from 'portal/store/ui/actions'
import { TableSettings } from './TableSettings'
export function TableSettingsButton() {
  const { moduleName } = useModuleIds()
  const dispatch = useDispatch()
  const shownColumns = useSelector(
    (state: any) =>
      state.ui.data[`${moduleName.toLowerCase()}ShownTableColumns`]
  )

  const DEFAULT_SHOWN_COLUMNS: string[] = useMemo(
    () =>
      moduleName === 'delivery'
        ? [
            'date',
            'deliveryId',
            'deliveryAddressKnown',
            'tradeContractor',
            'knownSupplierName',
            'assignedTo'
          ]
        : [
            'removalDate',
            'consignmentId',
            'carrierName',
            'originSiteAddressKnown',
            'wasteCode',
            'weight',
            'volume',
            'assignedTo'
          ],
    [moduleName]
  )

  useEffect(() => {
    // On mount, if shownColumns is null or an empty array,
    // load shown columns from localStorage or use default
    if (!shownColumns || shownColumns.length === 0) {
      const storedColumns = localStorage.getItem(
        `${moduleName.toLowerCase()}-shownTableColumns`
      )
      if (storedColumns) {
        dispatch(
          moduleName.toLowerCase() === 'delivery'
            ? uiSetShownDeliveryTableColumns(JSON.parse(storedColumns))
            : uiSetShownWasteTableColumns(JSON.parse(storedColumns))
        )
      } else {
        dispatch(
          moduleName.toLowerCase() === 'delivery'
            ? uiSetShownDeliveryTableColumns(DEFAULT_SHOWN_COLUMNS)
            : uiSetShownWasteTableColumns(DEFAULT_SHOWN_COLUMNS)
        )
        localStorage.setItem(
          `${moduleName.toLowerCase()}-shownTableColumns`,
          JSON.stringify(DEFAULT_SHOWN_COLUMNS)
        )
      }
    }
  }, [DEFAULT_SHOWN_COLUMNS, dispatch, moduleName, shownColumns])
  return (
    <ButtonContainer>
      <Popover
        content={<TableSettings moduleName={moduleName} />}
        placement="bottom"
        title="Table Settings"
        trigger="click"
        styles={{
          body: { maxHeight: 'calc(100vh - 226px)', overflowY: 'auto' }
        }}
      >
        <TSButton id="TableSettingsButton">
          <icons.Settings size={sizes.SMALL} colour={colours.BATTLESHIP_GREY} />
          <Spacer.Fine />
          Table Settings
        </TSButton>
      </Popover>
    </ButtonContainer>
  )
}

const ButtonContainer = styled(Flex.Col)`
  flex: 0 0 auto;
  align-items: flex-end;
`
const TSButton = styled(ColourButton.Basic)`
  border-radius: 25px;
  color: ${colours.DARK_GREY};
  background-color: ${colours.WHITE};
  border-color: ${colours.BORDER_GREY};

  &:hover {
    background: transparent;
    color: ${colours.DARK_GREY};
    border-color: ${colours.DARK_GREY};
  }

  &:focus {
    color: ${colours.DARK_GREY};
    background-color: ${colours.WHITE};
  }

  &:hover:focus {
    background: transparent;
  }

  > SVG {
    color: ${colours.BATTLESHIP_GREY};
  }

  &:hover > SVG {
    color: ${colours.CHARCOAL_GREY};
  }
`
